// extracted by mini-css-extract-plugin
module.exports = {"input-width":"_5BdxTzmhLPQh_Asd-c25p","container":"_3xlVCmsxlu7A09-4BWtwmM","content":"_3FLnnbu6Ltx_33Ohew1P4n","flex":"_1mGp6TAdl1k9EjTIxO22c1"};